/**
 * Analyysisivun osiot — sama oletus kuin AdminSettings.
 */
export const DEFAULT_ANALYTICS_SECTIONS = [
  { id: 'summary', name: 'Yhteenveto', visible: true, expanded: true, order: 0 },
  { id: 'longestGames', name: 'Pisimmät pelit', visible: true, expanded: true, order: 1 },
  { id: 'mostPlayed', name: 'Suosituimmat pelit', visible: true, expanded: true, order: 2 },
  { id: 'winRates', name: 'Voittoprosentit', visible: true, expanded: true, order: 3 },
  { id: 'winStreaks', name: 'Voittoputket', visible: true, expanded: false, order: 4 },
  { id: 'highestScores', name: 'Korkeimmat pisteet', visible: true, expanded: false, order: 5 },
  { id: 'closestGames', name: 'Tasaisimmat pelit', visible: true, expanded: false, order: 6 },
  { id: 'playerFavorites', name: 'Pelaajien suosikit', visible: true, expanded: false, order: 7 },
  { id: 'monthlyActivity', name: 'Kuukausiaktiivisuus', visible: true, expanded: false, order: 8 },
  { id: 'headToHead', name: 'Keskinäiset kohtaamiset', visible: true, expanded: false, order: 9 },
  { id: 'avgPointsPerGame', name: 'Keskimääräinen menestyspisteansio', visible: true, expanded: true, order: 10 }
];

export function getOrderedVisibleSections(settings) {
  if (!settings?.sections?.length) {
    return [...DEFAULT_ANALYTICS_SECTIONS].sort((a, b) => a.order - b.order);
  }
  return [...settings.sections]
    .filter((s) => s.visible !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function buildExpandedMapFromSections(sections) {
  const o = {};
  (sections || []).forEach((section) => {
    o[section.id] = section.expanded === true;
  });
  return o;
}
